import { useEffect as reactUseEffect, useRef } from 'react';

export function useEffect(effect, deps, options = {}) {
  const { cleanup, trackDeps, onCleanup } = options;
  const cleanupRef = useRef();
  const depsRef = useRef();

  // Track dependency changes if enabled
  if (trackDeps && deps) {
    const depsChanged = !depsRef.current || !deps.every((dep, index) => dep === depsRef.current[index]);
    if (depsChanged) {
      console.log('Dependencies changed:', { old: depsRef.current, new: deps });
      depsRef.current = [...deps];
    }
  }

  reactUseEffect(() => {
    // Execute the effect
    const cleanupFn = effect();
    
    // Store cleanup function
    if (typeof cleanupFn === 'function') {
      cleanupRef.current = cleanupFn;
    }

    // Return cleanup function
    return () => {
      if (cleanup && cleanupRef.current) {
        cleanupRef.current();
        cleanupRef.current = undefined;
      }
      if (onCleanup) {
        onCleanup();
      }
    };
  }, deps);
}

export default useEffect;
